import React from 'react'
import classes from './Global.module.css'

function MessageButton() {
  return (
    <div className={classes.message_btn}>
        <button className=""><i className="fa-solid fa-envelope"></i> <span>Message</span></button>
    </div>
  )
}

export default MessageButton